const KES_PER_USD = 130;

export function convertAmount(amount, currency = "KES") {
  const numericAmount = Number(amount);

  if (Number.isNaN(numericAmount)) return null;
  if (currency === "USD") return numericAmount / KES_PER_USD;
  return numericAmount;
}

export function formatMoney(amount, currency = "KES", fallback = "—") {
  const convertedAmount = convertAmount(amount, currency);

  if (convertedAmount === null) return fallback;

  return new Intl.NumberFormat(currency === "KES" ? "en-KE" : "en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(convertedAmount);
}

export { KES_PER_USD };
